export const MAX_CHARACTER_RATING = 5; // Mainly for semantic purposes

export const CHAT_MESSAGE_MAX_LENGTH = 10000;

export enum CharacterRating {
  LIKE = 3,
  DISLIKE = 1,
  LOVE = MAX_CHARACTER_RATING,
}

export enum CharacterRatingWeights {
  LIKE = 0.5,
  DISLIKE = -1.0,
  LOVE = 1.0,
}

export enum ChatPageModal {
  SHOW_VOICE_SELECION_MODAL,
  SHOW_VOICE_UPGRADE_MODAL,
  SHOW_SHARE,
  SHOW_MODEL_SETTINGS,
  SHOW_BLOCK_MODAL,
  UPDATE_CLONE_TITLE_MODAL,
  CONVERSATION_MEMORY_MODAL,
  CHANGE_PERSONA_CONFIRMATION_MODAL,
  CLONE_CONVERSATION_MODAL,
  CHATBOT_RATING_MODAL,
}
